import Preloader from "components/Preloader/Preloader";
import {
  fetchGalleryItems,
  selectGalleryIsLoading,
  selectGalleryItems,
} from "features/gallery/gallerySlice";
import { UIGalleryItemType } from "features/gallery/types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import Project from "./components/Project";

interface OurProjectsProps {}

const OurProjects: React.FC<OurProjectsProps> = ({}) => {
  const galleryItems = useSelector(selectGalleryItems);
  const isLoading = useSelector(selectGalleryIsLoading);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGalleryItems());
  }, []);

  console.log(galleryItems);

  return (
    <OurProjectsContainer>
      {/* title */}
      <h3>Галерия на нашите проекти</h3>
      {isLoading ? (
        <Preloader />
      ) : (
        <ProjectsContainer>
          {galleryItems?.map((item: UIGalleryItemType, id: number) => {
            return <Project key={id} item={item} />;
          })}
        </ProjectsContainer>
      )}
    </OurProjectsContainer>
  );
};

const OurProjectsContainer = styled.div`
  padding: 20px 10px;

  @media only screen and (${device.laptop}) {
    padding: 30px 20px;
  }

  @media only screen and (${device.desktop}) {
    padding: 30px 0;
  }
`;

const ProjectsContainer = styled.div`
  display: flex;
  flex-flow: column;
`;

export default OurProjects;
